var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{key:`ck-editor-${_vm.key}`,attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"disabled":_vm.ready ? _vm.disabled : false,"value":_vm.value},on:{"input":_vm.change,"ready":_vm.onReady}}),_c('div',{class:`text-right text-caption ${_vm.dataUsage.color}`},[_vm._v(" "+_vm._s(_vm.dataUsage.percentText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }